import type { IFrame, IRotateAndFlip } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';

export function isFlipH(style: IRotateAndFlip): boolean {
    return style?.flipH === 1;
}

export function isFlipV(style: IRotateAndFlip): boolean {
    return style?.flipV === 1;
}

function hasRotate(style: IRotateAndFlip): boolean {
    return style?.rotate !== undefined;
}

export function transformOfFlip(style: IRotateAndFlip): string {
    let transform = '';
    if (isFlipH(style)) {
        transform = `${transform} scaleX(-1)`;
    }
    if (isFlipV(style)) {
        transform = `${transform} scaleY(-1)`;
    }
    return transform;
}

export function transformOfFlipH(style: IRotateAndFlip): string {
    let transform = '';
    if (isFlipH(style)) {
        transform = `${transform} scaleX(-1)`;
    }
    return transform;
}

export function transformOfFlipV(style: IRotateAndFlip): string {
    let transform = '';
    if (isFlipV(style)) {
        transform = `${transform} scaleY(-1)`;
    }
    return transform;
}

export function transformOfRotate(style: IFrame, needTranslate = false): string {
    let transform = '';
    if (needTranslate) {
        transform = `translate(${style.left} ${style.top})`;
    }

    if (hasRotate(style)) {
        if (needTranslate) {
            transform = `${transform} rotate(${style.rotate}, ${style.width / 2}, ${style.height / 2})`;
        } else {
            transform = `${transform} rotate(${style.rotate}deg)`;
        }
    }
    return transform;
}
export function transformOfRotateAndFlip(style: IRotateAndFlip): string {
    let transform = '';
    if (hasRotate(style)) {
        transform = `${transform} rotate(${style.rotate}deg)`;
    }
    if (isFlipH(style)) {
        transform = `${transform} scaleX(-1)`;
    }
    if (isFlipV(style)) {
        transform = `${transform} scaleY(-1)`;
    }

    return transform;
}

export function textTransformStyleOfFlip(style: IRotateAndFlip): string {
    let transform = '';
    let flipH = 0;
    let flipV = 0;
    if (isFlipH(style)) {
        flipH = 1;
    }
    if (isFlipV(style)) {
        flipV = 1;
        flipH = flipH === 1 ? 0 : 1;
    }
    if (flipH) {
        transform = `${transform} scaleX(-1)`;
    }
    if (flipV) {
        transform = `${transform} scaleY(-1)`;
    }
    return transform;
}

export interface AnimStyle {
    scaleX?: number;
    scaleY?: number;
}
export function transformOfFlipForAnimation(style: IRotateAndFlip, animStyle: AnimStyle): string {
    let transform = '';
    if (animStyle) {
        let tranScale = '';
        if (animStyle?.scaleX) {
            tranScale = `${tranScale} scaleX(${animStyle.scaleX})`;
        } else if (style.flipH) {
            tranScale = `${tranScale} scaleX(-1)`;
        }

        if (animStyle?.scaleY) {
            tranScale = `${tranScale} scaleY(${animStyle.scaleY})`;
        } else if (style.flipV) {
            tranScale = `${tranScale} scaleY(-1)`;
        }
        transform = transform + tranScale;
    } else {
        transform = transformOfFlip(style);
    }
    return transform;
}

export const testObj = {
    isFlipH,
    isFlipV,
    hasRotate,
};
